import BaseModelAPI from '../BaseModelAPI';

export default class Lookup extends BaseModelAPI {
	static entity = 'lookup';
	static entityName = 'lookup';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.lookupDetails = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}